import vButton from './Button.vue';

export { vButton };



// WEBPACK FOOTER //
// ./src/modules/sign/baseComponents/Button/index.js